module.exports = __webpack_public_path__ + "img/hartalocalitatijudarad.93ffceba.png";